import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { DeviceInfoDiv } from '../component/device-info/DeviceInfoDiv';

export const DeviceInfoPage = () => (
  <MainPageLayout elementCentr={<DeviceInfoDiv />} />
);
